export default __webpack_public_path__ + "static/studio1-7c9ad8d4abb4c9e8a02afcba2dade5ba.png";